import * as cn from 'classnames'
import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'
import PaginatorArrow from 'components/atoms/tables/PaginatorArrow'

const onClick = () => { /* do nothing */}

const SGIcons = () => (
  <section className={ cn(styles.sgSection, styles.sgIcons) }>
    <ul>
      <li>
        <PaginatorArrow direction='left' kind='single' onClick={ onClick } />
        <Caption text='Left Single Arrow' />
      </li>
      <li>
        <PaginatorArrow direction='left' kind='double' disabled onClick={ onClick } />
        <Caption text='Left Double Arrow' />
      </li>
      <li>
        <PaginatorArrow direction='right' kind='single' disabled onClick={ onClick } />
        <Caption text='Right Single Arrow' />
      </li>
      <li>
        <PaginatorArrow direction='right' kind='double' onClick={ onClick } />
        <Caption text='Right Double Arrow' />
      </li>
    </ul>
  </section>
)

export default SGIcons
